import React from "react";
import { Card, CardContent } from "@mui/material";
import TasksPanel from "./TasksPanel";

const card = { border: "1px solid #dfe4e1", borderRadius: 16, boxShadow: "none" };
const number = value => Number(value || 0).toLocaleString("pt-BR", { maximumFractionDigits: 1 });

function Metric({ label, value }) {
  return <Card style={card}><CardContent>
    <small style={{ color: "#718078", letterSpacing: ".12em" }}>{label.toUpperCase()}</small>
    <div style={{ fontSize: 27, fontWeight: 800, marginTop: 7 }}>{value}</div>
  </CardContent></Card>;
}

export default function TasksDashboard({ data = {}, users, isAdmin, onChanged }) {
  return <div style={{ display: "grid", gap: 10 }}>
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(210px,1fr))", gap: 10 }}>
      <Metric label="Tarefas em atraso" value={number(data.overdue)} />
      <Metric label="Total criadas" value={number(data.total)} />
      <Metric label="Taxa de conclusão" value={`${number(data.completionRate)}%`} />
      <Metric label="Agentes em risco" value={number(data.agentsAtRisk)} />
    </div>
    <TasksPanel users={users} isAdmin={isAdmin} onChanged={onChanged} />
  </div>;
}
